import React from "react"
import { useSiteMetadata } from "../hooks/use-site-metadata"

export const Seo = ({ title, description, pathname, children, image, ogType }) => {
    const { title: defaultTitle, description: defaultDescription, siteUrl, twitterUsername, twitterCardType } = useSiteMetadata().site.siteMetadata

    const defaultImage = useSiteMetadata().image.edges[0].node.childImageSharp.gatsbyImageData.images.fallback.src

    const defaultPathname = ""

    const seo = {
        title: title || defaultTitle,
        description: description || defaultDescription,
        image: `${siteUrl}${image || defaultImage}`,
        url: `${siteUrl}${pathname || defaultPathname}`,
        twitterUsername,
        ogType: ogType || "website",
        twitterCardType: twitterCardType || "summary"
    }
    return (
        <>
            <html lang="en" />
            <title>{seo.title}</title>

            <meta name="description" content={seo.description} />
            <meta name="image" content={seo.image} />

            <meta name="twitter:card" content={seo.twitterCardType} />
            <meta name="twitter:title" content={seo.title} />
            <meta name="twitter:url" content={seo.url} />
            <meta name="twitter:description" content={seo.description} />
            <meta name="twitter:image" content={seo.image} />
            <meta name="twitter:creator" content={seo.twitterUsername} />
            <meta name="twitter:site" content={seo.twitterUsername} />

            <meta name={`og:type`} content={seo.ogType} />
            <meta name={`og:title`} content={title} />
            <meta name={`og:description`} content={seo.description} />
            <meta property="og:image" content={seo.image} />
            <meta property="og:url" content={seo.url} />
            <meta property="og:site_name" content="Caucasus Edition" />

            <link rel="canonical" href={seo.url} />


            <meta name={`robots`} content={`index, follow`} />

            <meta name="viewport" content="width=device-width,initial-scale=1" />

            {children}

        </>
    )
}